import { NgModule } from '@angular/core';
import { HoldersHomeModule } from './holders-home.module';
import { EmpusaMicroAppType } from '@empusa/empusa-core';

@NgModule({
  declarations: [],
  imports: [],
  exports: []
})
export class HoldersModule {
  name: string = "holders";
  description: string = "Poseedores"
  icon: string = "holders";
  page: any = HoldersHomeModule;
  homeApp: boolean = false;
  path: string = "holders";
  order: number = 1;
  resourceServerId: string = "keycloak-auth-manager-resources-server";
  appType: EmpusaMicroAppType = EmpusaMicroAppType.home;

  constructor() {
    //we register ourselves
    (<any>window).empusa(this);
    console.debug("Load microapp " + this.name);
  }
 }
